import { LocalStorageManager } from "../storage/local-storage-manager";

export abstract class SettingsService {
	constructor(storagePrefix: string) {
		this.storagePrefix = storagePrefix;
	}

	protected storagePrefix: string;

	public readonly getKey = (suffix: string, key: string = "default") => {
		return `nautilus_${this.storagePrefix}_${key}_${suffix}`;
	}

	public readonly setItem = (key: string, data: any) => {
		let setData = data != null ? data.toString() : data;
		LocalStorageManager.getInstance().setItem(key, setData);
	}

	public readonly getItem = (key: string, defaultResult: any = null) => {
		let result = LocalStorageManager.getInstance().getItem(key);
		return result != null ? result : defaultResult;
	}
}